import React from "react";
import { Header, Icon } from "semantic-ui-react";

const ProductKnowledgeSummary = ({ pkEvaluation }) => {
  if (!pkEvaluation) return null;

  // The score itself is in the report's tiles (pkScoreDisplay); this is the product and 요약.
  const { product, result } = pkEvaluation;
  const productName = product ? product.name : "알 수 없는 제품";

  return (
    <div style={{ padding: '10px 0' }}>
       <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1em' }}>
          <Icon name="box" style={{ color: '#666', marginRight: '8px' }} />
          <span style={{ fontWeight: '600', color: '#1d1d1f' }}>{productName}</span>
       </div>

        {result && result.summary && (
            <div style={{ marginTop: '1.5rem', backgroundColor: '#f9fafb', padding: '15px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.05)' }}>
                <Header as="h5" style={{ marginBottom: '8px' }}>
                    <Icon name="file text outline" />
                    <Header.Content>평가 요약</Header.Content>
                </Header>
                <p style={{ color: '#424245', fontSize: '0.95em', lineHeight: '1.5' }}>
                    {result.summary}
                </p>
            </div>
        )}
    </div>
  );
};

export default ProductKnowledgeSummary;
